module.exports = __webpack_public_path__ + "static/media/Logo SHBS.1d3069bb.png";